import React, { useEffect, useMemo } from 'react';
import { createIntl, createIntlCache, RawIntlProvider, IntlShape } from 'react-intl';
import { useLocale } from 'entities/application';

import { useGetTranslates } from './useGetTranslates';
import { setLocale } from '../storageLocale';

interface Props {
  children: JSX.Element;
};

const intlCache = createIntlCache();
export let intl: IntlShape;

export const Translations = (props: Props) => {
  const { children } = props;

  const currentLocale = useLocale();
  const translates = useGetTranslates(currentLocale);

  useEffect(() => {
    document.documentElement.lang = currentLocale;
    setLocale(currentLocale);
  }, [currentLocale]);

  const intlValue = useMemo(() => {
    intl = createIntl({
      locale: currentLocale,
      messages: translates
    }, intlCache);

    return intl;
  }, [currentLocale, translates]);

  return (
    <RawIntlProvider value={intlValue}>
      {children}
    </RawIntlProvider>
  );
};
